import { ChevronDown } from "lucide-react";
import { Dropdown } from "@praesto/ui-kit";

/** "Aggiungi" split intent: invite by email vs create with password.
 *  The trigger is a styled span (not a Button) because ui-kit Dropdown wraps
 *  its trigger in its own <button> — a nested button would be invalid HTML. */
export function AddUserDropdown(props: { onInvite: () => void; onCreate: () => void }) {
  return (
    <Dropdown
      align="right"
      triggerAriaLabel="Aggiungi una persona"
      trigger={
        <span className="inline-flex min-h-touch items-center gap-1.5 rounded-pill bg-fg-default px-5 font-sans text-sm font-semibold text-fg-inverse transition-colors duration-fast hover:bg-fg-strong">
          Aggiungi
          <ChevronDown size={16} aria-hidden />
        </span>
      }
      items={[
        { type: "item", label: "Invita via email", onClick: props.onInvite },
        { type: "item", label: "Crea con password", onClick: props.onCreate },
      ]}
    />
  );
}
